// extracted by mini-css-extract-plugin
export default {"modalControl":"modalControl_modalControl__xd8VH","exitButton":"modalControl_exitButton__8c5kY","confirmButton":"modalControl_confirmButton__GwW8B"};